export default __webpack_public_path__ + "static/media/logo-rtl.069fd8da.svg";